var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.649,
    height: 21.664,
    viewBox: "0 0 22.649 21.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{fill:#e11e24;stroke:#e11e24;stroke-width:.5px}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_",
    transform: "translate(0.064 -1.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    d: "M.349 22.717h21.824L11.261 1.842zm1.462-.885l9.45-18.078 9.45 18.078z",
    className: "cls-1",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    d: "M24 18h.885v6.744H24z",
    className: "cls-1",
    transform: "translate(-13.182 -9.006)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    d: "M24 39h.885v.878H24z",
    className: "cls-1",
    transform: "translate(-13.182 -21.26)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d32ea72ecc1296ebe976e221ae31abe2.svg";
export { ForwardRef as ReactComponent };